<template>
  <div class="product-item-step-bd product-param clear">
    <div class="product-param-info">
      <div class="tips">
        <i class="icon icon-tishi"></i>
        <span class="tips-content">{{ $t('dms_product_item_step_param.cpcsyyjsqjjxxtxqjssz') }}</span>
      </div>
      <el-form :model="modelForm" :rules="rules" ref="form" class="form">
        <el-form-item :label="$t('dms_product_item_step_param.lun_zi_zhi_jingm')" prop="wheelDiameter">
          <el-input type="number" v-model.number="modelForm.wheelDiameter" style="width: 260px" :min="0"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_param.lun_zi_zhou_changm')" prop="wheelPerimeter">
          <el-input type="number" v-model.number="modelForm.wheelPerimeter" style="width: 260px" :min="0"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_param.shua_zi_kuan_dum')" prop="brushWidth">
          <el-input type="number" v-model.number="modelForm.brushWidth" style="width: 260px" :min="0"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_param.chan_pin_ti_jim')" prop="productVolume">
          <el-input type="number" v-model.number="modelForm.productVolume" style="width: 260px" :min="0"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_param.zxqjmjlzzcszkd')" prop="minCleanArea">
          <el-input type="number" v-model.number="modelForm.minCleanArea" style="width: 260px" :min="0"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_param.jzqjmjt')" prop="basicArea">
          <el-input type="number" v-model.number="modelForm.basicArea" style="width: 260px" :min="0"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_product_item_step_param.jzqjscmint')" prop="basicTime">
          <el-input type="number" v-model.number="modelForm.basicTime" style="width: 260px" :min="0"></el-input>
        </el-form-item>
          <el-form-item :label="$t('dms_product_item_step_param.dcsjrl')" prop="designCapacity">
          <el-input type="number" v-model.number="modelForm.designCapacity" style="width: 260px" :min="0"></el-input>
        </el-form-item>
        <!-- <el-form-item
          :label="
            $t('label_max_turns_num_per_hour
          "
          prop="maxTurnsNumPerHour"
        >
          <el-input
            type="number"
            v-model.number="modelForm.maxTurnsNumPerHour"
            style="width:260px;"
            :min="0"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item
          :label="
            $t('label_daily_max_work_hours + ' (h)'
          "
          prop="maxWorkHourPerDay"
        >
          <el-input
            type="number"
            v-model.number="modelForm.maxWorkHourPerDay"
            style="width:260px;"
            :min="0"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item
          :label="
            $t('label_daily_max_charge_hours + ' (h)'
          "
          prop="maxChargingHourPerDay"
        >
          <el-input
            type="number"
            v-model.number="modelForm.maxChargingHourPerDay"
            style="width:260px;"
            :min="0"
          ></el-input>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" @click="onSave(false)">{{ $t('Common.com_save') }}</el-button>
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('dms_product_item_step_param.sybcpxx') }}</el-button>
      <el-button type="primary" @click="onSave(true)">{{ $t('dms_product_item_step_param.xybcpxy') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    productId: [String, Number],
  },
  data() {
    return {
      modelForm: {
        // 轮子直径
        wheelDiameter: '',
        // 轮子周长
        wheelPerimeter: '',
        // 刷子宽度
        brushWidth: '',
        // 最小清洁面积
        minCleanArea: '',
        // 体积
        productVolume: '',
        // 基准面积（平方米）
        basicArea: '',
        // 基准时长（分钟）
        basicTime: '',
        designCapacity: '',
        // 每日最大工作时长
        // maxWorkHourPerDay: '',
        // 最大充电时长
        // maxChargingHourPerDay: '',
        // 每小时最大圈数
        // maxTurnsNumPerHour: ''
      },
    };
  },
  mounted: function () {
    this.getInfo();
  },

  computed: {
    rules() {
      return {
        minCleanArea: [
          { required: true, message: this.$t('Common.com_required') },
          { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
        wheelPerimeter: [
          { required: true, message: this.$t('Common.com_required') },
          { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
        wheelDiameter: [
          { required: true, message: this.$t('Common.com_required') },
          { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
        productVolume: [
          { required: true, message: this.$t('Common.com_required') },
          { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
        brushWidth: [
          { required: true, message: this.$t('Common.com_required') },
          { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
        basicArea: [
          { required: true, message: this.$t('Common.com_required') },
          { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
        basicTime: [
          { required: true, message: this.$t('Common.com_required') },
          { type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
      };
    },
  },
  methods: {
    getModelForm(cleanWheelParam) {
      const ret = {
        wheelPerimeter: '',
        wheelDiameter: '',
        brushWidth: '',
        minCleanArea: '',
        productVolume: '',
        // maxWorkHourPerDay: '',
        // maxChargingHourPerDay: '',
        // maxTurnsNumPerHour: ''
      };
      if (!cleanWheelParam) {
        return ret;
      }
      const obj = JSON.parse(cleanWheelParam);
      return Object.assign(ret, obj);
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    getInfo() {
      if (this.getJump('productId')) {
        this.$getJSON(apis.ProductParamDetail, {
          productId: this.productId,
        }).then((res) => {
          this.modelForm = this.getModelForm(res.data.cleanWheelParam);
        });
      }
    },
    getSaveReqData() {
      return {
        basicArea: this.modelForm.basicArea || null,
        basicTime: this.modelForm.basicTime || null,
        designCapacity: this.modelForm.designCapacity || null,
        cleanWheelParam: JSON.stringify(this.modelForm),
        productId: this.productId,
      };
    },
    // 基本信息之后的模块都是update
    save() {
      return this.$postJSON(apis.ProductParamSave, this.getSaveReqData());
    },
    onSave(next) {
      this.$refs.form.validate((val) => {
        if (val) {
          this.save().then(() => {
            if (next) {
              this.$emit('step', { name: 'param', productId: this.productId });
            } else {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.product-param {
  padding-bottom: 60px;
  overflow: hidden;

  .product-param-info {
    .tips {
      line-height: 32px;
      padding-left: 10px;
      background: rgba(249, 200, 81, 0.15);
      .icon {
        color: #f9c851;
      }
      .tips-content {
        padding-left: 10px;
        font-size: 12px;
        color: #6c757d;
      }
    }

    .form {
      width: 400px;
      margin-top: 15px;

      .el-form-item__label {
        width: 100%;
        text-align: left;
      }
    }

    .form-section {
      .el-form-item__label {
        color: #495057 !important;
        font-weight: bold;
        width: 100%;
        text-align: left;
        margin-left: -6px;
      }

      .el-textarea__inner {
        height: 63px !important;
      }
    }
  }
}
</style>
